import React from "react";
import "./tasks-content.component.scoped.scss";
import TodoWrapperComponent from "../tasks-wrapper/tasks-wrapper.component";

export default function TasksContentComponent() {
  return <TodoWrapperComponent />;
}
